import React, { memo } from 'react';
import propTypes from 'prop-types';

import { Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function SupportContactCard({ name, phone }) {
  return (
    <Columns className="support-contact-card">
      <Column isSize="narrow">
        <span className="icon is-large has-text-grey-lighter">
          <FontAwesomeIcon icon={['fal', 'user-headset']} size="2x" />
        </span>
      </Column>
      <Column>
        <MuiTitle isSize="7" hasTextColor="primary">
          {name}
        </MuiTitle>
        <p className="phone has-text-secondary">{phone}</p>
      </Column>
    </Columns>
  );
}

SupportContactCard.propTypes = {
  name: propTypes.string.isRequired,
  phone: propTypes.string.isRequired,
};

const memoizedSupportContactCard = memo(SupportContactCard);

export { memoizedSupportContactCard as SupportContactCard };
